import React from 'react'

import {
  AppearingWrapper,
  CTAParagraph,
  SectionContainer,
} from 'Components/Blocks'
import { Button, Column, Text } from 'Components/UI'

import {
  LANDING_CONTENT_PX,
  LANDING_CONTENT_WIDTH_PX,
  LANDING_SECTION_GAP,
  LANDING_SECTION_PY,
} from 'Constants/Landing'

import { useResponsiveLayout } from 'Hooks'

import Gallery from './Gallery'
import Title from './Title'

type Props = {
  onAction?: () => void
}

function MoreThanJustGolfSection({ onAction }: Props) {
  const { isMobile } = useResponsiveLayout()

  return (
    <SectionContainer px={LANDING_CONTENT_PX}>
      <AppearingWrapper centered>
        <Column
          alignCenter
          fullWidth
          gap={LANDING_SECTION_GAP}
          maxWidth={LANDING_CONTENT_WIDTH_PX}
          py={LANDING_SECTION_PY}
        >
          <Title />

          <Gallery />

          <Column alignCenter gap={15}>
            <Column maxWidth={825}>
              <CTAParagraph
                centered
                text={
                  <>
                    &#34;The curated introductions and quality of conversations
                    consistently put us in front of decision-makers who value
                    long-term partnerships. All while playing some of
                    Australia&#39;s best golf courses.&#34;
                  </>
                }
              />

              <Text
                bold
                center
                important
                lineHeight="32px"
                mt={7}
                preWrap
                screen20
              >
                - Graham Shannin,{isMobile ? '\n' : ' '}National Sign Build
              </Text>
            </Column>

            <Button large width={isMobile ? 1 : undefined} onClick={onAction}>
              Book a Meeting
            </Button>
          </Column>
        </Column>
      </AppearingWrapper>
    </SectionContainer>
  )
}

export default MoreThanJustGolfSection
